// extracted by mini-css-extract-plugin
module.exports = {"container":"Phrase_container__1wyBV","phrase":"Phrase_phrase__1dMiC","openQuote":"Phrase_openQuote__14BUH","closeQuote":"Phrase_closeQuote__3yIJL"};